import create from 'zustand'
import {devtools} from 'zustand/middleware'
import { undoMiddleware, UndoState } from 'zundo'

const useProfileStore = create(
    undoMiddleware((set) => ({
      selectedPts:[],
      addSelectedPts: (pt) => set((state) => ({selectedPts: [...state.selectedPts, pt]})),
      replaceSelectedPts: (ptsArray) => set((state) => {state.selectedPts = ptsArray}),
      clearSelectedPts: () => set((state) => ({selectedPts:[]})),
      totalLength:0,
      setTotalLength:(len) => set((state) => ({totalLength: len}))
  }),
      {omit:['totalLength', 'setTotalLength']}
  ))



export default useProfileStore